import { render, staticRenderFns } from "./TeamLead.vue?vue&type=template&id=b35d3bf6&"
import script from "./TeamLead.vue?vue&type=script&lang=js&"
export * from "./TeamLead.vue?vue&type=script&lang=js&"
import style0 from "./TeamLead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports